import picture from "@/assets/impact.jpg?w=640;960;1280;1600&format=avif;webp;jpg&quality=70&as=picture";
import type { MarketingPicture } from "@/lib/marketing-images";

export const impactPic = picture as MarketingPicture;
